import axios from "axios";

const mapData = (result) => result.data;

const http = {
  get: (path, filters = {}, headers = {}) =>
    axios.get(path, { params: filters, headers }).then(mapData),
  post: (path, data, headers = {}) =>
    axios.post(path, data, headers).then(mapData),
  put: (path, data, headers = {}) =>
    axios.put(path, data, headers).then(mapData),
  delete: (path, headers = {}) => axios.delete(path, headers).then(mapData),
};

export default http;
